'use client';

import {useRouter} from 'next/navigation';
import {useTranslation} from 'react-i18next';
import type {DetailPageAnalytics} from '../../analytics';
import {specChipLabel, type UnitTypeCardView} from '../../model';
import {ListingCard} from '../listing';
import {SoldOutLabel} from '../primitives';
import {unitSpecIcon} from './unit-spec-icons';

export interface UnitTypeCardProps {
  unit: UnitTypeCardView;
  href: string;
  analytics: DetailPageAnalytics;
  onRegisterInterest: (unit: UnitTypeCardView) => void;
}

export function UnitTypeCard({unit, href, analytics, onRegisterInterest}: UnitTypeCardProps) {
  const {t} = useTranslation();
  const router = useRouter();
  const tracked = {id: unit.uuid, name: unit.title};
  return (
    <ListingCard
      title={unit.title}
      image={unit.image.src}
      href={href}
      tags={unit.soldOut ? <SoldOutLabel label={t('sold_out')} /> : undefined}
      badges={[{label: unit.contextLabel}]}
      meta={unit.specs.map(spec => ({icon: unitSpecIcon(spec.key, 'sm'), label: specChipLabel(t, spec)}))}
      onClick={() => {
        analytics.carouselCard(tracked, 'unit_types');
      }}
      hoverActions={[
        {
          label: t('register_interest'),
          onClick: () => {
            onRegisterInterest(unit);
          },
        },
        {
          label: t('view_details'),
          onClick: () => {
            analytics.carouselCard(tracked, 'unit_types');
            router.push(href);
          },
        },
      ]}
    />
  );
}

UnitTypeCard.displayName = 'UnitTypeCard';
